import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AuthGuard, CmsConfig, ConfigModule, I18nModule, TranslatePipe } from '@spartacus/core';
import { SpinnerModule } from '@spartacus/storefront';
import { KnBrCustomerContextGuard } from 'src/app/shared/guards/kn-br-customer-context.guard';
import { KnBrOrderConfirmationLedgerComponent } from './kn-br-order-confirmation-ledger.component';
@NgModule({
  declarations: [KnBrOrderConfirmationLedgerComponent],
  imports: [
    CommonModule,
    SpinnerModule,
    FormsModule,
    ReactiveFormsModule,
    TranslatePipe,
    I18nModule,
    ConfigModule.withConfig({
      cmsComponents: {
        CarlisleOrderConfirmationLedgerHeaderComponent: {
          component: KnBrOrderConfirmationLedgerComponent,
          guards: [AuthGuard],
        },
      },
    } as CmsConfig),
  ],
})
export class KnBrOrderConfirmationLedgerModule {}
